
define('template!ordersDetailOrderProductOptionEditOptionView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'fsfsdfsdffsd';

}
return __p
};});

